module.exports = __webpack_public_path__ + "system/img/personal-icon-01.72cd4f8f.png";